import { Component, OnInit } from '@angular/core';
import { TemplateUpdateService } from '../../../services/template-update.service';
@Component({
  selector: 'searchbox-accessibility',
  templateUrl: './searchbox-accessibility.component.html',
  styleUrls: ['./searchbox-accessibility.component.sass']
})
export class SearchboxAccessibilityComponent implements OnInit {
  infoText = this.templateService.accessibilityInfoText;
  header = this.templateService.accessibilityHeader;

  constructor(private templateService: TemplateUpdateService) { }

  ngOnInit(): void {
  }

}
